import BaseModule from '@/store/baseModule';
import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';

const attributesObj = {
  id: {
    serverSide: true,
    values: ['2', '3', '5'],
  },
};

export default (store) => {
  store.registerModule(
    ['requests', 'states'],
    new BaseModule({
      attributesObj,
      serviceAPI: new BaseService({
        api: new BaseAPI({ url: `${process.env.P2C_BASE_URI}/request_states` }),
        retry: { nbLeft: 3, timeout: 2000 },
      }),
      makeQueryParams: makeListRequest({}),
    })
  );

  store.dispatch('requests/states/initItems');
};
